module.exports = __webpack_public_path__ + "static/media/18-2.c57ce6c9.jpg";